import * as React from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { fetchProjects as fetchProjectsRequest } from 'api/Project/Action'
import { Project } from 'types/Project'

type AssignProjectProps = {
  onChange: (value: Project | null) => void
}

const AssignProject = ({ onChange }: AssignProjectProps) => {
  const [projects, setProjects] = React.useState([])
  const { t } = useTranslation()

  const fetchProjects = async () => {
    const response: [] = await fetchProjectsRequest()

    if (Array.isArray(response)) setProjects(response)
  }

  React.useEffect(() => {
    fetchProjects()
  }, [])

  const handleChange = (_: React.SyntheticEvent, value: Project | null) => {
    onChange(value)
  }

  return (
    <Autocomplete
      options={projects}
      getOptionLabel={(option: any) => option.name}
      id="select-project"
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('participant.note.selectProjectLabel')}
          variant="standard"
        />
      )}
      noOptionsText={t('participant.note.selectProjectLoadingText')}
      onChange={handleChange}
      ListboxProps={{ style: { maxHeight: 190 } }}
      data-testid="note-assign-project"
    />
  )
}

export default AssignProject
